import React from 'react';
import { Link } from 'react-router-dom';
import Availability from '../components/Availability.jsx';
import ContactForm from '../components/ContactForm.jsx';

export default function Contact() {
  return (
    <>
      <h2 className="page-header">Contact</h2>
      <section>
        <p className="contact-email-note">
          You can also email me directly at
          {' '}<a href="mailto:mikeroymoe@gmail.com">mikeroymoe@gmail.com</a>.
          {' '}Prefer a one-pager?
          {' '}<Link to="/resume">View the resume</Link>.
        </p>
        <ContactForm />
        <Availability />
      </section>
    </>
  );
}
